import { Component, ViewContainerRef } from '@angular/core';
import { ManuManagement } from '../../models/manu-management/manu-management-model';
import { ManuManagementService } from '../../services/manu-mangement/manu-management.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
    selector: 'app-create-manu-management',
    templateUrl: './create-manu-management.component.html',
    styleUrls: ['./create-manu-management.component.css']
})
/** create-manu-management component*/
export class CreateManuManagementComponent {
    /** create-manu-management ctor */
  public manu = new ManuManagement();
  validate: boolean;
  constructor(private readonly manuMangementService: ManuManagementService, public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("menumanagement").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.manu.isActive = true;
            this.manu.manuType = null;
            this.manu.target = null;
            this.validate = true;
            this.manu.sortOrder = 0;

          }
          else {
            this.router.navigate(["/manu-list"]);
          }
        }
        else {
          this.router.navigate(["/manu-list"]);
        }
      }
    )
    }
isActiveCheckbox(e) {
    this.manu.isActive = e.target.checked;
  }

  onSubmit() {
    this.validate = false;
    this.manuMangementService.AddManu(this.manu).subscribe(result => {
      if (result) {
        this.toastr.success('Menu has been Saved.', 'Success');
        setTimeout(() => {
          this.router.navigate(["/manu-list"]);
        }, 2000);
      }
      else {
        this.toastr.error('Error occurred. Oop!', 'Error');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/manu-management-component/create-manu-management/create-manu-management.component.ts